import legalContentJson from '../config/legal-content.json';

interface LegalSection {
  title: string;
  content: string;
  list?: string[];
  subsections?: { title: string; content: string; }[];
  security?: { title: string; measures: string[]; };
}

interface ContactInfo {
  title: string;
  content: string;
  email: string;
  website?: string;
  committee?: string;
}

interface Principle {
  icon: string;
  title: string;
  description: string;
  color: string;
}

interface TermsContent {
  title: string;
  sections: LegalSection[];
  contact: ContactInfo;
}

interface PrivacyContent {
  title: string;
  subtitle: string;
  principles: Principle[];
  sections: LegalSection[];
  contact: ContactInfo;
}

interface EthicsContent {
  title: string;
  subtitle: string;
  principles: Principle[];
  sections: LegalSection[];
  promise: { title: string; content: string; };
  contact: ContactInfo;
}

export interface LegalContent {
  lastUpdated: string;
  disclaimer: TermsContent;
  termsOfService: TermsContent;
  privacyPolicy: PrivacyContent;
  aiEthics: EthicsContent;
}

const bundledLegalContent = legalContentJson as LegalContent;

/**
 * Legal copy for Hyper AI (bundled). Terms, Privacy, Ethics, and Disclaimer modals read from this.
 */
export const useLegalContent = () => ({
  content: bundledLegalContent,
  loading: false,
  error: null as string | null,
});

/**
 * Get icon component by name
 */
export const getIconComponent = (iconName: string) => {
  // This would need to be expanded based on the icons you want to support
  const iconMap: Record<string, any> = {
    'Eye': 'Eye',
    'Lock': 'Lock', 
    'Database': 'Database',
    'Heart': 'Heart',
    'Shield': 'Shield',
    'Users': 'Users',
    'Brain': 'Brain'
  };
  
  return iconMap[iconName] || 'FileText';
};